import React from 'react';

import styles from './styles.scss'

export default class FormatAlertMessage extends React.Component {

    _focusOnFirstFieldError(fieldIndex, firstErrorFieldId) {
        if(fieldIndex === 0) {
            document.getElementById(firstErrorFieldId).focus();
        }
    }

    render() {
        const { genericMessage, error} = this.props;
        const errors = Object.entries(error)
        const fieldErrorValueIndex = 1;
        const fieldErrorNameIndex = 0;

        return (
            <ul className={styles['list']}>
                {genericMessage && (
                    <p>{genericMessage}</p>
                )}
                {errors.length > 0 && (
                    <p>Please correct the following errors:</p>
                )}
                {
                    errors.map((value, index) => {
                        let listOfErrors = value[fieldErrorValueIndex];
                        let fieldName = value[fieldErrorNameIndex];

                        return (
                            listOfErrors.map((value, fieldIndex) => {
                                this._focusOnFirstFieldError(index, fieldName + '_input')
                                return (
                                    <li>
                                        <a
                                            href={'#' + fieldName + '_input'}
                                            aria-label={fieldName + ' field error link'}
                                            aria-describedby={fieldName + ' field error link'}
                                        >
                                            {value}
                                        </a>
                                    </li>
                                )
                            })
                        )
                    })
                }
            </ul>
        )
    }

}